import React, { memo } from 'react';
export function StoryOrigin() {
  return <section className="w-full bg-brand-warm-white py-12 md:py-14 px-4 sm:px-6 lg:px-8 border-y border-gray-200" data-id="element-423" data-mp="2coagu7rvoyud">
      <div className="max-w-7xl mx-auto" data-id="element-424" data-mp="16kbd0ylola2p">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mb-16" data-id="element-425" data-mp="1befh9a3kb403">
          Why "Break a Pencil"?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 items-start" data-id="element-426" data-mp="1feg49j4q8nir">
          {/* Text */}
          <div className="md:col-span-7 space-y-8 text-xl text-brand-gray leading-relaxed" data-id="element-427" data-mp="iqjnad5dnq70">
            <p data-id="element-428" data-mp="noboxyvtqqoe">
              "Break a Pencil" was my dad's way of wishing someone good luck on
              any test or intellectual challenge. It was his twist on "break a
              leg."
              <span className="text-brand-orange font-bold" data-id="element-429" data-mp="wq1iba99nzot">*</span> He said it
              before every exam, and years later, I say the same thing to my
              kids before tests or big presentations.
            </p>
            <p data-id="element-430" data-mp="285q1rrnbagkv">
              He was my first boss and the person who most influenced who I am
              today. Break a Pencil Consulting is my way of honoring his memory
              while rooting for the leaders and teams I work with.
            </p>

            <div className="pt-8 mt-8 border-t border-gray-200 text-sm text-gray-500 italic" data-id="element-431" data-mp="1t868qactct6r">
              <span className="text-brand-orange font-bold not-italic mr-1" data-id="element-432" data-mp="1o936sys4r330">
                *
              </span>{' '}
              "Break a leg" is a traditional good-luck phrase in theater, where
              saying "good luck" is considered bad luck.
            </div>
          </div>

          {/* Photo */}
          <div className="md:col-span-5" data-id="element-433" data-mp="1aj82wf8576w5">
            <figure data-id="element-434" data-mp="15jn5484pl4l0">
              <div className="rounded-lg overflow-hidden shadow-lg aspect-[4/3]" data-id="element-435" data-mp="15k56tka54b0b">
                <img src="https://cdn.magicpatterns.com/uploads/oCQbiJRc24UhB8GgHnWnNW/Photo750529780121_inner_140-85-647-85-134-874-682-874.jpg" alt="Michael and his dad" className="w-full h-full object-cover object-[center_35%]" data-id="element-436" data-mp="10kai9ndu7xif" />
              </div>
              <figcaption className="mt-3 text-sm text-gray-500 italic text-center" data-id="element-437" data-mp="qx6i3x2o3upa">
                Me and my Dad (circa 2002)
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}